<template>
  <div class="aftersales">
    <div class="box">
      <div class="header">
        <div class="title">售后支持</div>
        <div class="border"></div>
      </div>
      <div class="body">
        <div class="list">
          <div class="item" v-for="item in aftersalesList" :key="item.id">
            <div class="top">
              <img class="logo" :src="item.logo" alt="" />
              <div class="content">
                <div class="title">{{ item.title }}</div>
                <div class="text">{{ item.text }}</div>
                  <div class="content-list">
                    <div
                      class="content-item"
                      v-for="(it, idx) in item.list"
                      :key="idx"
                    >
                      <img :src="yesLogo" alt="" />
                      <div>{{ it }}</div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import aftersalesLogo1 from "../../../assets/product/aftersalesLogo1.png";
import aftersalesLogo2 from "../../../assets/product/aftersalesLogo2.png";
import aftersalesLogo3 from "../../../assets/product/aftersalesLogo3.png";
import aftersalesLogo4 from "../../../assets/product/aftersalesLogo4.png";

import yesLogo from "../../../assets/product/yesLogo.png";

export default {
  setup() {
    return reactive({
      yesLogo: yesLogo,
      aftersalesList: [
        {
          id: 1,
          title: "呼叫中心",
          logo: aftersalesLogo1,
          text: "您可以拨打公司全国统一售后服务热线021-021-021，向呼叫中心客服人员实时咨询各种产品问题。",
          list: ["1v1人工服务", "24小时在线", "立刻响应"],
        },
        {
          id: 2,
          title: "线上咨询",
          logo: aftersalesLogo2,
          text: "您可以通过畅月数字家园的官方QQ或者官方客服随时进行咨询，帮您解决各种常见问题。",
          list: ["1v1人工服务", "24小时在线", "3分钟响应"],
        },
        {
          id: 3,
          title: "售后培训",
          logo: aftersalesLogo3,
          text: "我们会通过手机、电脑给物业远程开展培训及问题指导处理；也会在网络上开展相关业务培训，物业所有人员均可远程参与；根据用户需求，公司可派专业工程师到现场提供技术支持。",
          list: ["专业工程师团队", "耐心认真", "线上线下"],
        },
        {
          id: 4,
          title: "免费升级",
          logo: aftersalesLogo4,
          text: "随着社会的发展，我们的产品会一直不断的迭代、更新、升级，而您在使用期间可以免费享受这项服务。",
          list: ["紧跟时代", "一直更新", "免费享受"],
        },
      ],
    });
  },
};
</script>

<style scoped>
@media screen and (max-width: 1180px) {
  .aftersales {
    min-width: 1180px;
  }
}
.aftersales {
  width: 100%;
  height: 595px;
  background-image: url(../../../assets/product/aftersalesBack.png);
  margin-top: 80px;
}

.box {
  width: 1180px;
  margin: 0 auto;
  padding: 60px 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
  color: #fff;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body .list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 40px;
}
.body .list .item {
  width: 520px;
  padding: 30px;
  background-color: #fff;
  margin-bottom: 20px;
  border-radius: 5px 5px 5px 5px;
}
.body .list .item .top {
  display: flex;
}
.body .list .item .top .logo {
  height: 64px;
  margin-right: 20px;
}
.body .list .item .top .content .title {
  font-size: 18px;
}
.body .list .item .top .content .text {
  font-size: 12px;
  color: #6f8398;
  margin-top: 10px;
}

.body .list .item .top .content .content-list {
  display: flex;
  margin-top: 30px;
  justify-content: space-between;
}
.body .list .item .top .content .content-list .content-item {
  display: flex;
  align-items: center;
}
.body .list .item .top .content .content-list .content-item img {
  width: 12px;
  margin-right: 8px;
}
.body .list .item .top .content .content-list .content-item div {
  font-size: 14px;
}
</style>
